const isDevelopment = process.env.NODE_ENV === "development";
const isProduction = process.env.NODE_ENV === "production";

// Define URLs for different environments
const SERVICE_URLS = {
  development: {
    api: "https://studibudi-api-254180344632.us-central1.run.app",
    //    api: 'https://studibudi-api-staging-254180344632.us-central1.run.app',
    websocket: "wss://studibudi-live-254180344632.us-central1.run.app/ws",
  },
  staging: {
    api: "https://studibudi-api-254180344632.us-central1.run.app",
    //    api: 'https://studibudi-api-staging-254180344632.us-central1.run.app',
    websocket: "wss://studibudi-live-254180344632.us-central1.run.app/ws",
  },
  production: {
    api: "https://studibudi-api-254180344632.us-central1.run.app",
    //    api: 'https://studibudi-api-staging-254180344632.us-central1.run.app',
    websocket: "wss://studibudi-live-254180344632.us-central1.run.app/ws",
  },
};

// Smart environment detection
const getEnvironment = (): keyof typeof SERVICE_URLS => {
  // 1. Check for explicit environment variable override
  const envOverride = import.meta.env.VITE_ENVIRONMENT;
  if (envOverride && envOverride in SERVICE_URLS) {
    return envOverride as keyof typeof SERVICE_URLS;
  }

  // 2. Auto-detect production from domain
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (
      hostname === "studibudi.ai" ||
      hostname === "studibudi.com" ||
      hostname === "www.studibudi.ai" ||
      hostname === "www.studibudi.com"
    ) {
      return "production";
    }
  }

  // 3. Default to staging for safety (better than production for previews)
  return "staging";
};

export const config = {
  // Backend API URL
  BACKEND_API_URL: (() => {
    if (import.meta.env.VITE_BACKEND_API_URL) {
      return import.meta.env.VITE_BACKEND_API_URL;
    }
    // Use smart environment detection
    const environment = getEnvironment();
    return SERVICE_URLS[environment].api;
  })(),

  // WebSocket URL
  WEBSOCKET_URL: (() => {
    if (import.meta.env.VITE_WEBSOCKET_URL) {
      return import.meta.env.VITE_WEBSOCKET_URL;
    }
    // Use smart environment detection
    const environment = getEnvironment();
    return SERVICE_URLS[environment].websocket;
  })(),

  // Live Protocol WebSocket URL (official Multimodal Live server)
  LIVE_WEBSOCKET_URL: (() => {
    if (import.meta.env.VITE_LIVE_WEBSOCKET_URL) {
      return import.meta.env.VITE_LIVE_WEBSOCKET_URL as string;
    }
    // Use smart environment detection to get the correct WebSocket URL
    const environment = getEnvironment();
    return SERVICE_URLS[environment].websocket;
  })(),

  // Environment checks
  isDevelopment,
  isProduction,

  // Debug info
  nodeEnv: process.env.NODE_ENV || "undefined",
  detectedEnvironment: getEnvironment(),
} as const;

import { devLogger } from "./dev-logger";

// Debug logging in development
if (isDevelopment) {
  devLogger.log("🔧 Service Config:", {
    NODE_ENV: process.env.NODE_ENV,
    detectedEnvironment: config.detectedEnvironment,
    BACKEND_API_URL: config.BACKEND_API_URL,
    WEBSOCKET_URL: config.WEBSOCKET_URL,
    LIVE_WEBSOCKET_URL: config.LIVE_WEBSOCKET_URL,
    api_override: import.meta.env.VITE_BACKEND_API_URL || "none",
    websocket_override: import.meta.env.VITE_WEBSOCKET_URL || "none",
    live_websocket_override: import.meta.env.VITE_LIVE_WEBSOCKET_URL || "none",
    env_override: import.meta.env.VITE_ENVIRONMENT || "none",
  });
}
